import { bindActionCreators } from 'redux';
import React, { Component} from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import Tours from '../components/Tours';
import TourPreview from './tours/Preview';
import Header from './layout/Header';
import Map from './Map';
import * as toursActions from '../actions/tours';
import { Link } from 'react-router';
import * as TourActions from '../actions/tour';
import Helmet from "react-helmet";
import Translate from './layout/Translate';
import Facebook from './popups/Facebook';



class Landmarks extends Component {

    
    componentWillMount() {


        this.props.toursActions.setMapConfig({
            showBoundedObjects: false,
            type: 'ROADMAP',
            active: false,
            fixed: true,
            listByMap: false
        });

        this.props.toursActions.fetchLandmarks(this.props.params.param_id?this.props.params.param_id:'');

    }

    componentWillUnmount() {


        this.props.toursActions.setMapConfig({
            fixed: false
        });

    }


    selectLandmark(landmark) {
        this.props.toursActions.selectLandmark(landmark);
    }

    loadLandmarks(page) {
        this.props.toursActions.fetchLandmarks(page);
    }

    cropDescription(text) {

        let description = "";
        let re = /<[^>]+>/g;
        if (text) {
            description = (text) ? text.replace(re, '') : "";
            description = description.substr(0, 205);
            let lastSpace = description.lastIndexOf(" ");
            if (lastSpace > 0 && description.length > 200) {
                description = description.substr(0, lastSpace);
            }
            description += "...";
        }

        return description;
    }

    render () {
        const { landmarks, seo, translations } = this.props;

        let page = this.props.params.param_id?parseInt(this.props.params.param_id):1

        let pagination = [];
        for (var i=1; i <= landmarks.pageCount; i++) {
            pagination.push(<Link className={"pagination__item " + ((page==i)?'pagination__item_active':'')} onClick={this.loadLandmarks.bind(this, i)} to={"/info/landmarks" + (i>1?'/page/'+i:'')}>{i}</Link>);
        }

        let link = [

        ];


        {page>1 &&
            link.push({"rel": "canonical", "href": "/info/landmarks"});
        }

        return (

            <section className="section " ref="main">
                <Helmet
                    title={(seo.title)?seo.title:translations['destination__landmarks']}
                    link={link}
                >
                </Helmet>
                <div className="section__content">
                    <Header />
                    <div>

                        <div className="container">

                               



                            <div className="navigate">
                                 <h1 style={{fontSize: '36px'}}><Translate slug="destination__landmarks" /></h1>

                                <div className="navigate__landmarks landmark">
                                    {landmarks.list.map((landmark, i) =>
                                        <span>
                                                <div className="navigate__landmark">
                                                    <h2 className="landmark__title">
                                                        <Link to={'/info/landmarks/' + landmark.slug} className="map__info" onClick={this.selectLandmark.bind(this, landmark)}>
                                                            {landmark.title}
                                                        </Link>
                                                    </h2>
                                                    <Link className="landmark__text" to={'/info/landmarks/' + landmark.slug} onClick={this.selectLandmark.bind(this, landmark)}>
                                                        {this.cropDescription(landmark.content)}
                                                    </Link>
                                                </div>
                                            </span>
                                    )}
                                </div>

                                <div className="pagination">
                                    {pagination}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <Facebook />

            </section>
        );
    }
}


Landmarks.need = [
    {
        action: toursActions.fetchLandmarks
    }
];



function mapStateToProps(state) {

    return {
        landmarks: state.tours.landmarks,
        seo: state.user.seo,
        translations: state.user.translations
    };
}


function mapDispatchToProps(dispatch) {
    return {
        toursActions: bindActionCreators(toursActions, dispatch)
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Landmarks)





// WEBPACK FOOTER //
// ./src/common/components/Landmarks.js